<template>
    <aside calss="flex wrap center" :class="{ 'collapsed': collapsed }">
        <i class="fe fe-x x" data-toggle="toggle" @click.prevent="collapsed = true"></i>
        <div class="logo flex wrap center">
            <a class="flex wrap center" href="https://atiyehiraniancf.com" target="_blank">
                <img v-if="collapsed" class="brand" v-lazy="'/images/wicon.webp'" height="42" width="42">
                <img v-else v-lazy="'/images/hlogo.webp'">
            </a>
        </div>
        <div class="navbar">
            <template v-for="(category, cindex) in modules['categories']" :key="cindex">
                <div class="categories">
                    <p class="category">{{ category.name }}</p>
                    <ul>
                        <template v-for="(menu, mindex) in modules['menus'].filter(menu => {
                            return menu.category === category.id || (!menu.category && category.id === 0)
                        })" :key="mindex">
                            <li class="items flex wrap vcenter">
                                <a class="flex wrap center vcenter" :class="[{ 'active': active[menu.id] },
                                { 'single': base.Util().validate(menu.route) }]"
                                    :href="menu.route ? menu.route : '#M' + menu.id" data-toggle="collapse"
                                    @click.prevent="() => {
                                        if (menu.route)
                                            route(menu.extras, menu.route)
                                        else {
                                            collapsed = false
                                            opened[menu.id] = !opened[menu.id]
                                        }
                                    }">
                                    <i v-if="menu.symbol" :class="menu.symbol"></i>
                                    <span class="flex wrap space vcenter">{{ menu.name }}</span>
                                </a>
                                <transition name="slide-fade">
                                    <ul v-if="!collapsed && opened[menu.id]" class="flex wrap"
                                        :class="{ 'collapse': !opened[menu.id] }" :id="'M' + menu.id">
                                        <template v-for="(option, oindex) in modules['options'].filter(option => {
                                            return option.menu === menu.id
                                        })" :key="oindex">
                                            <li class="flex wrap vcenter">
                                                <a :class="{ 'active': active[option.id] }"
                                                    @click.prevent="route(option.extras, option.route)">
                                                    <p>{{ option.name }}</p>
                                                </a>
                                            </li>
                                        </template>
                                    </ul>
                                </transition>
                            </li>
                        </template>
                    </ul>
                </div>
            </template>

            <div v-if="fullscreen && !collapsed" class="full flex wrap center vcenter">
                <button @click.prevent="collapsed = true">بستن منو</button>
            </div>
        </div>
    </aside>
    <a href="tel:+982591004810">
        <div v-if="!collapsed" class="contact flex wrap center vcenter">
            <p>آتیا همیشه و در همه جا </p>
            <p>025-91004810</p>
        </div>
    </a>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Aside',
    props: ['authenticated', 'toggle', 'location', 'data'],
    inject: ['base'],
    created() {
        if (window.screen.width <= 430) {
            this.collapsed = true
            this.fullscreen = true
        }
    },
    data() {
        return {
            collapsed: this.toggle,
            fullscreen: false,
            modules: this.data || {},
            active: {},
            opened: {}
        }
    },
    watch: {
        toggle(newToggle, oldToggle) {
            this.collapsed = this.toggle
        },
        data: {
            handler(newData, oldData) {
                this.modules = this.data
            },
            deep: true
        },
        collapsed(newCollapsed, oldCollapsed) {
            if (this.fullscreen && !this.collapsed)
                document.body.style.overflow = 'hidden'
            else if (this.fullscreen && this.collapsed)
                document.body.style.overflow = null

            this.$emit('onchange', {
                collapsed: this.collapsed
            })
        }
    },
    methods: {
        route(extras, route) {
            let extra = this.base.Entities().parse(extras)
            if (extra['params'])
                route = route.replace(`{${extra['params']}}`, this.$cookies.get(extra['params']))

            if (!extra['type'] || extra['type'] === 'route') {
                let hash = ''
                let query = {}
                if (String(route).includes('?'))
                    String(route).split('?')[1].split('&').forEach((q) => {
                        query[q.split('=')[0]] = q.split('=')[1] || ''
                    })
                if (String(route).includes('#'))
                    hash = `#${route.split('#')[1]}`
                this.$router.push({ path: route, query: query, hash: hash })
            }
            else if (extra['type'] === 'newtab')
                window.open(route)
            else if (extra['type'] === 'action')
                switch (route) {
                    case 'logout':
                        this.base.Security().logout(['/dashboard'])
                        break
                    case 'raychat':
                        let element = document.getElementById('raychat_widget')
                        if (element) {
                            element.style.display = 'block';
                            (element.contentDocument
                                || element.contentWindow.document)?.getElementsByClassName('sc-closed-icon')[0]?.click()
                            if (window.screen.width <= 430)
                                this.widget()
                        }
                        break
                    default:
                        break
                }

            if (this.fullscreen) {
                this.collapsed = true
                this.opened = {}
            }
        },
        widget() {
            let element = document.getElementById('raychat_widget')
            if (element)
                setTimeout(() => {
                    if (!(element.contentDocument || element.contentWindow.document)?.getElementsByClassName('messaging_page_wrapper')[0])
                        element.style.display = 'none'
                    else
                        setTimeout(() => this.widget(), 250)
                }, 500)
        }
    }
}
</script>

<style scoped src="../assets/css/components/aside.css"></style>
<style scoped src="../assets/css/components/aside_dark.css"></style>